/**
 *
 * Asynchronously loads the component for BallValveIcon
 *
 */

import { lazyLoad } from 'utils/loadable';

export const BallValveIcon = lazyLoad(
  () => import('./index'),
  module => module.BallValveIcon,
);
